export const APP_PATHS = {
  login: 'connexion',
  resetPassword: 'reinitialisation-mot-de-passe',
  activity: 'activite',
  offer: 'offre',
  archive: 'archive',
  brokers: 'mes-courtiers',
} as const;

export const APP_URLS = {
  root: '/',
  login: `/${APP_PATHS.login}`,
  resetPassword: `/${APP_PATHS.resetPassword}`,
  activity: `/${APP_PATHS.activity}`,
  offer: `/${APP_PATHS.offer}`,
  archive: `/${APP_PATHS.archive}`,
  brokers: `/${APP_PATHS.brokers}`,
} as const;
